import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import loadConfig from "../../Services/apiService";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
const DateInput = (props) => {
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [date, SetDate] = useState(props.date);
  //[,]
  //this function to get data from main.json file by fieldsName props
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    let fieldsName = props.fieldsName;
    let code = jsonData[fieldsName];
    SetDataJsonObject(code);
  };
  //console.log(props.date, "date");

  useEffect(() => {
    dataJson();
  }, []);
  return dataJsonObject ? (
    <>
      <div className="containerInputAHSF">
        <div className="label-container">
          <label for={dataJsonObject.code} title={dataJsonObject.nameEN}>
            {dataJsonObject.nameAR}
            {dataJsonObject.isRequired ? <span>*</span> : ""}
          </label>
          {props.showValidationMessage && (
            <span
              className="validation-icon"
              data-tooltip={props.validationMessage}
            >
              <FontAwesomeIcon icon={faCircleExclamation} />
              &nbsp;
            </span>
          )}
        </div>
        <DatePicker
          selected={date != "" ? date : false}
          placeholderText="dd/MM/yyyy"
          onChange={(e) => {
            // //console.log(e);

            SetDate(e);
            props.onChange(e);
          }}
          dateFormat="dd/MM/yyyy"
          minDate={
            new Date(
              dataJsonObject.startDateYear,
              dataJsonObject.startDateMonth,
              dataJsonObject.startDateDay
            )
          }
          maxDate={props.maxDate}
          scrollableYearDropdown
          //   showDisabledMonthNavigation
          showMonthDropdown
          showYearDropdown
          //    showMonthYearPicker
          dropdownMode="select"
          //   isClearable
          className={props.showValidationMessage ? "input-error" : ""}
          autoComplete="off"
          id={props.list ? dataJsonObject.code : "date-post"}
          disabled={props.disabled}
          filterDate={props.filterDate ? (date) => date.getDate() === 1 : ""} // السماح باختيار اليوم الأول فقط
        />
      </div>
    </>
  ) : (
    ""
  );
};

export default DateInput;
